import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Category } from '../Models/category';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class CategoryService {

  constructor(
    private http: HttpClient,
    private config: Config,
    private languageService: LanguageService) { }

    list(): Observable<Category[]> {
      // categories depend on language hence the flatmap
      return this.languageService.getLanguage().flatMap(
        value => {
          return this.http.get<Category[]>(this.config.getURL('categories'));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/Services/category.ts